import emailInputCss from "./lib/email-input-css";
import emailInputJs from "./lib/emails-input";
import emailInputUtil from "./lib/utils";

function callOnRender(data) {
  let count = 0;
  if (data.emailEnabled) {
    count++;
  }
  if (data.smsEnabled) {
    count++;
  }
  if (data.facebookEnabled) {
    count++;
  }
  if (data.twitterEnabled) {
    count++;
  }
  return count;
};

export default (reward, tourCtaUrl, data) => {

  const count = callOnRender(data);
  return `
<style>
@import url("https://fonts.googleapis.com/css?family=Raleway");
@import url("https://fonts.googleapis.com/css?family=Open+Sans");

input:focus {outline:0;} 
button:focus {outline:0;} 
${emailInputCss}

body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 700px;
  margin: 0 16px;
}

.hyraf-thanks-form{
  max-width:500px;
  width:100%;
  margin: auto;
  background: white;
}
.hyraf-thanks-form-header{
  height: 80px;
 background:${data.orgColors ? data.orgColors.buttonBackgroundColor : '#27bbed'};
  color:${data.orgColors ? data.orgColors.buttonFontColor : 'white'};
  border:${data.orgColors ? data.orgColors.buttonBorderColor : '#27bbed'};
  display: flex;
  align-items: center;
  position: relative;
  justify-content: center;
}
.hyraf-thanks-form-header span{
  font-size: 24px;
  color: white;
  font-weight: 600;
  font-family: "Open Sans", sans-serif;
}
.hyraf-thanks-form-header .close-btn{
  background:transparent;
  border:none;
  font-size: 30px;
  color:white;
  font-weight: 100;
  position: absolute;
  right: 30px;
}

.hyraf-thanks-form .content{
  padding:20px 20px 30px 20px;
  border: 1px solid #DADADA;
  border-top:none;
}

.hyraf-thanks-form .content .content-heading{
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
}

.hyraf-thanks-form .content .content-subheading{
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
  margin-top:30px;
}

.hyraf-thanks-form .content .content-label{
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: rgba(51, 51, 51, 0.75);
  margin-top:30px;
}

.hyraf-thanks-form .content .content-small-label{
  margin-top:30px;
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
}

.hyraf-thanks-form .content input{
  border: none;
  border-bottom: 1px solid #dadada;
  width: 100%;
  margin-top: 20px;
}

.hyraf-thanks-form .content .top{
  background: #f3fbfe;
  text-align: center;
  padding: 20px;
  border-radius: 20px;
}

.hyraf-thanks-form .content .submit-btn{
  width: 240px;
  height: 48px;
  background:${data.orgColors ? data.orgColors.buttonBackgroundColor : '#27bbed'};
  color:${data.orgColors ? data.orgColors.buttonFontColor : 'white'};
  border:${data.orgColors ? data.orgColors.buttonBorderColor : '#27bbed'};
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  cursor:pointer;
}
.hyraf-thanks-form .footer{
  text-align: right;
  margin-top: 20px;
}
.hyraf-copy-link{
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  display: flex;
  align-items: center;
  color: #999999;
  justify-content:space-between;
  border:1px solid #eeeeee;
  height:35px;
  margin-top:10px;
  padding-left:10px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.hyraf-copy-link button{
  height: 35px;
  border: none;
  background: transparent;
  width: 80px;
  border-left: 1px solid #eeeeee;
  color: #333333;
  cursor:pointer;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  font-family: "Open Sans", sans-serif;
}

.share-buttons-queue-thankyou{
  display:flex;
  justify-content:${count < 3 ? 'space-around' : 'space-between'};
  margin-top:10px;
}

.share-buttons-queue-thankyou button{
   width: 146px;
  height: 86px;
  background: #F9F9F9;
  border-radius: 10px;
  border: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor:pointer;
}
.share-buttons-queue-thankyou button span{
  margin-top:10px;
  color:#333333;
}
.copied-btn{
  background: #66D184 !important;
  box-shadow: inset 1px 0px 0px #DADADA;
  color:white !important;
  width: 80px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.copied-btn svg{
  display:block !important;
}
.copy-btn svg{
  display:none;
} 
@media only screen and (max-width: 480px) {
  .hyraf-thanks-form-header{
    height: 60px;
  }
  .hyraf-thanks-form-header span{
    font-size: 18px;
  }
  .hyraf-thanks-form-header .close-btn{
    right: 10px;
    font-size:25px;
  }
  .hyraf-thanks-form .content .content-heading{
    font-size: 16px;
    line-height: 20px;
  }

  .share-buttons-queue-thankyou{
    display: grid;
    justify-content: space-between;
    margin-top: 10px;
    gap: 10px;
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  }
  .share-buttons-queue-thankyou button{
    width:auto;
    height: 44px;
    background: #F9F9F9;
    border-radius: 10px;
    border: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .share-buttons-queue-thankyou button span{
    margin-top:0;
    margin-left:5px;
  }
  .hyraf-copy-link{
    font-size: 12px;
  }
}

  .copy-url{
    max-width: calc(100% - 85px);
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    display:flex;
  }

  .copy-url-icon{
    margin-top:2px;
    margin-right: 4px;
  }

</style>
<script>
${emailInputUtil}
</script>
<script>
${emailInputJs}
</script>

<div class="hyraf-thanks-form">
  <div class="hyraf-thanks-form-header">
    <span>${data.popupTitle}</span>
    <button class="close-btn"  type="button" onclick="closeSocialPreview('thanks-popup', 'true')">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19 5L5 19" stroke="white" stroke-miterlimit="10" stroke-linecap="square"/>
        <path d="M19 19L5 5" stroke="white" stroke-miterlimit="10" stroke-linecap="square"/>
      </svg>
    </button>
  </div>
  <div class="content">
   
  <div class="top">
    <img src="data:image/png;base64,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" />
    <div>${data.popupMessage && data.popupMessage.replace(/\n/g, '<br/>')}</div>
  </div>
   <div  class="content-small-label">Share Via</div>
    <div class="share-buttons-queue-thankyou">
     ${data.emailEnabled ? `<button onclick="openSocialPreview('email-popup')">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z" fill="#333333"/>
        </svg>
        <span>Email</span>
      </button>` : ""}
         ${''
    //      data.smsEnabled ? `<button onclick="openSocialPreview('sms-popup')">
    //   <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    //     <path d="M20 2H4C2.9 2 2.01 2.9 2.01 4L2 22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM13 14H11V12H13V14ZM13 10H11V6H13V10Z" fill="#333333"/>
    //   </svg>
    //   <span>SMS</span>
    // </button>` : ""
    }
         ${data.facebookEnabled ? `<button onclick="openSocialPreview('fb-popup')">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M24 12.073C24 5.446 18.627 0.072998 12 0.072998C5.373 0.072998 0 5.446 0 12.073C0 18.063 4.388 23.027 10.125 23.927V15.542H7.078V12.072H10.125V9.43C10.125 6.423 11.917 4.761 14.658 4.761C15.97 4.761 17.344 4.996 17.344 4.996V7.949H15.83C14.339 7.949 13.874 8.874 13.874 9.823V12.073H17.202L16.67 15.543H13.874V23.928C19.612 23.027 24 18.062 24 12.073Z" fill="#333333"/>
        </svg>
        <span>Facebook</span>
      </button>` : ""}
         ${data.twitterEnabled ? `<button onclick="openSocialPreview('twitter-popup')">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M23.953 4.57003C23.0545 4.96563 22.1026 5.22677 21.128 5.34503C22.1541 4.72828 22.9224 3.76107 23.291 2.62203C22.34 3.17703 21.286 3.58103 20.164 3.80603C19.4238 3.01446 18.4429 2.48945 17.3736 2.31253C16.3044 2.13561 15.2067 2.31668 14.2509 2.82762C13.2952 3.33856 12.5349 4.15078 12.0881 5.13815C11.6412 6.12552 11.533 7.2328 11.78 8.28803C7.69 8.09503 4.067 6.13003 1.64 3.16203C1.19879 3.91184 0.968664 4.76705 0.974 5.63703C0.974 7.34703 1.844 8.85003 3.162 9.73303C2.38086 9.70816 1.61697 9.49696 0.934 9.11703V9.17703C0.933557 10.3134 1.32627 11.415 2.04551 12.2948C2.76474 13.1746 3.76621 13.7785 4.88 14.004C4.1583 14.1974 3.40241 14.2265 2.668 14.089C2.98412 15.067 3.59766 15.922 4.42301 16.5345C5.24837 17.1471 6.24435 17.4867 7.272 17.506C5.53153 18.872 3.38248 19.6133 1.17 19.611C0.78 19.611 0.391 19.588 0 19.544C2.25571 20.9884 4.87851 21.755 7.557 21.753C16.61 21.753 21.555 14.257 21.555 7.76803C21.555 7.55803 21.555 7.34803 21.54 7.13803C22.506 6.44289 23.3392 5.57985 24 4.59003L23.953 4.57003Z" fill="#333333"/>
        </svg>
        <span>Twitter</span>
      </button>` : ""}

     
      

    </div>
    
    <div class="content-label">Choose one of the platforms above or copy the link below to share via your preferred method</div>
    <div class="hyraf-copy-link">
      <span id="referralLink2" class="copy-url">
      <span class="copy-url-icon">
       <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.1003 9.23349C12.4003 10.5335 12.4003 12.6335 11.1003 13.9335L9.23359 15.8335C7.93359 17.1335 5.83359 17.1335 4.53359 15.8335C3.23359 14.5335 3.23359 12.4335 4.53359 11.1335L6.20026 9.53349" stroke="#333333" stroke-miterlimit="10" stroke-linecap="square" />
      <path d="M9.23379 11.1C7.93379 9.79996 7.93379 7.69996 9.23379 6.39996L11.1005 4.49996C12.4005 3.19996 14.5338 3.19996 15.8338 4.49996C17.1338 5.79996 17.1338 7.89996 15.8338 9.19996L14.1671 10.8333" stroke="#333333" stroke-miterlimit="10" stroke-linecap="square" />
        </svg> 
      </span>
      ${tourCtaUrl}</span>
      <button class="copy-btn"  onclick="copyToClipboard2(this)">
        <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 8.5L6 10.5L11 5.5" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="square"/>
        </svg>
        <span>Copy</span>
      </button>
    </div>
  </div>
</div>
<script>
  function copyToClipboard2(btn){
     setTimeout(() => {
      btn.children[1].innerHTML = "Copy";
      btn.className="copy-btn"
    }, 2000);
    let text = document.getElementById("referralLink2").innerHTML;
    navigator.clipboard.writeText(text).then(function () {
      btn.children[1].innerHTML = "Copied";
      btn.className="copied-btn"
    }, function (err) {
      console.error('Async: Could not copy text: ', err);
    });
  }
</script>

`}